// Generic picker — dropdown <details> z tabelą wierszy. Każdy wiersz to opcja z radio buttonem.
// Klik wiersza zaznacza radio, aktualizuje etykietę w <summary>, przesuwa highlight (bg-blue-50) i zwija <details>.
// Connects to data-controller="radio-picker"
//
// Używane w:
//   - app/views/kb/knowledge_bases/_form.html.erb         (pole comments_auto_approve — kogo auto-akceptować)
//   - app/views/kb/comments/_form.html.erb                 (pole moderation_status — status komentarza w edycji)
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["details", "summary", "radio", "row"]

  pick(event) {
    const row = event.currentTarget
    const value = row.dataset.value
    if (!value) return

    const radio = this.radioTargets.find(r => r.value === value)
    if (!radio) return

    radio.checked = true
    const label = radio.dataset.label
    if (label) {
      this.summaryTarget.textContent = label
    }

    this.rowTargets.forEach(r => {
      if (r === row) {
        r.classList.remove("bg-white", "hover:bg-gray-50")
        r.classList.add("bg-blue-50")
      } else {
        r.classList.remove("bg-blue-50")
        r.classList.add("bg-white", "hover:bg-gray-50")
      }
    })

    this.detailsTarget.removeAttribute("open")
  }
}
